<template>
  <div class="brand-section" v-if="cart_items_count">
    <div class="brand-img">
      <div class="bg-size">
        <img
          :src="logoUrl"
          @error="logoUrl = cart_brand.data.company_logo || ''"
          class="img-fluid"
          :alt="_T_DB(cart_brand.data, 'name')"
          :title="_T_DB(cart_brand.data, 'name')"
        />
      </div>
    </div>
    <div class="brand-detail">
      <!-- <h6>{{ _T('Fast food') }}</h6> -->
      <h3>{{ _T_DB(cart_brand.data, 'name') || '' }}</h3>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      logoUrl: '',
    }
  },
  watch: {
    cart_brand(brand) {
      if (brand && brand.logo) {
        this.logoUrl = brand.logo.replace(
          'company_logos',
          'company_logos/large'
        )
      }
    },
  },
  computed: {
    ...mapGetters([
      '_T',
      '_T_DB',
      'all_brands',
      'currentBrand',
      'find_brand_by_main_id',
      'cart_items_count',
      'cart_items',
      'cart_brand',
      'siteDomain',
    ]),
  },
  methods: {},
  beforeMount() {},
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
.brand-section {
  padding: 1.875rem;
  display: flex;
  align-items: center;
  border-bottom: $px1 solid $light-border;
  .brand-img {
    margin-right: 1.563rem;
    .bg-size {
      width: $px128;
      height: $px64 !important;
      border-radius: $px10;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      border: $px3 solid rgba(var(--color-dark-border-source), 0.9);
      padding: $px2;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        //  display: none;
      }
    }
  }
  .brand-detail {
    h6 {
      text-transform: uppercase;
      line-height: 1.375rem;
      letter-spacing: 0.005em;
      color: $light-font;
      margin-bottom: 0;
    }
    h3 {
      margin-bottom: 0;
      line-height: 1.813rem;
      letter-spacing: 0.02em;
      color: $font-color;
      font-weight: 700;
      text-transform: capitalize;
    }
  }
}
</style>
